import { render, staticRenderFns } from "./RecommendationBasedNewspaper.vue?vue&type=template&id=399a67d8&scoped=true&"
import script from "./RecommendationBasedNewspaper.vue?vue&type=script&lang=js&"
export * from "./RecommendationBasedNewspaper.vue?vue&type=script&lang=js&"
import style0 from "./RecommendationBasedNewspaper.vue?vue&type=style&index=0&id=399a67d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399a67d8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
